// extracted by mini-css-extract-plugin
module.exports = {"flat":"_view_flat__2-LN9"};